import React from 'react'
import RowComponent from './RowComponent'

export interface Props {
  content: any
  testId: string
}

export const TimeHorizon = ({ content, testId }: Props) => {
  return (
    <div className='TimeHorizon' data-testid={testId ? `${testId}-content` : null}>
      <div dangerouslySetInnerHTML={{ __html: content.milestone.intro }}></div>
      <section className='u-paddingVert48 u-sizeConstrained'>
        <div className='Journeys Journey-central u-md-paddingHoriz40 subhead u-posRelative'>
          {content.milestone.milestones.map((item: any) => (
            <RowComponent
              contentDesc={item.textContent}
              milestoneColor={item.bgcolor}
              milestoneMonthDesc={item.label}
              key={item.label}
              leftAligned={item.alignment === 'Left Aligned'}
            />
          ))}
        </div>
      </section>
    </div>
  )
}
